import { Cart } from "@/types/Cart";
import IProduct from "@/models/protocols/IProduct";
import User from "@/models/User";
// import Country from "@/models/Country";

export default {
  cart: new Cart(),
  user: new User(),
  products: new Array<IProduct>(),
  regions: {},
  underMaintenance: false,
} as any;
